<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <layout-no-padding>
            <go-back></go-back>
            <page-title :routeProps="routeProps"></page-title>
          </layout-no-padding>

          <div class="vertical-center-container text-xs-right">
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm6 lg3>
            <v-autocomplete
              label="Choose filter"
              :items="filterCols"
              v-model="filterCol"
              prepend-icon="list"
              :clearable="true"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>
          <div>
            <chip-display></chip-display>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>
      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        :color="$store.state.global.pages.allocation.color"
        class="overlap-fab"
        @click="addBatchDialog = !addBatchDialog"
        v-if="$store.state.user.userAuthClass.allocationStagingEntry"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>

    <filter-drawer></filter-drawer>
    <batch-add-wrapper v-model="addBatchDialog"></batch-add-wrapper>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import RouteProps from "@/services/mixins/routeProps";

import { addDays } from "date-fns";
import FormatDates from "@/services/mixins/formatDates";
import DateRangeOptions from "@/services/mixins/dateRangeOptions";

import FilterDrawer from "@/components/trips/filterDrawer";
import DatePickerWrapper from "@/components/ui/datePickerWrapper";

import BatchAddWrapper from "@/modules/batchAllocations/wrapper";

import ChipDisplay from "@/components/ui/chipDisplay";
export default {
  mixins: [RouteProps, FormatDates, DateRangeOptions],
  data() {
    return {
      addBatchDialog: false,
      filterCols: [
        {
          value: "date",
          text: "Date"
        },
        {
          value: "site.project.name",
          text: "Project"
        },
        {
          value: "site.name",
          text: "Site"
        },
        {
          value: "spoil.name",
          text: "Spoil"
        },
        {
          value: "day",
          text: "Day / Night"
        }
      ]
    };
  },
  components: {
    FilterDrawer,
    DatePickerWrapper,
    BatchAddWrapper,
    ChipDisplay
  },
  methods: {
    // toggleView() {
    //     this.listView = !this.listView;
    // },
  },
  computed: {
    filterCol: Store.getSet({ store: "allocationStaging", prop: "filterCol" }),
    filterBy: Store.getSet({ store: "allocationStaging", prop: "filterBy" }),
    filterDate: Store.getSet({ store: "allocations", prop: "filterDate" }),
    // dates: Store.getSet({store: 'allocations', prop: 'dates'}),
    // showClosed: Store.getSet({store: 'shared', prop: 'showClosed'}),
    // billingPeriod: Store.getSet({store: 'shared', prop: 'billingPeriod'}),
    // projectId: Store.getSet({store: 'shared', prop: 'projectId'}),
    drawer: Store.getSet({ store: "shared", prop: "drawer" })
    // projects: Store.getSet({store: 'projects', prop: 'projects'}),
    // projectObj() {
    //     return this.projects.filter(project => {
    //         return project.id == this.projectId
    //     })[0]
    // }
  },
  mounted() {
    // this.filterCol = null,
    // this.dates = [
    //     this.makeComputerDate(addDays(new Date(),-15)), //start date. YYYY-MM-DD
    //     this.makeComputerDate(new Date()), // end date. YYYY-MM-DD
    // ]
  }
};
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>